module.exports = __webpack_public_path__ + "media/TMFA.20d48d52.mp4";